import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { selectPreviousUrl } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { RouterError } from '../RouterHelpers/RouterError';
import { ProjectSpaceProvider, ProjectSpaceProviderProps } from './ProjectSpaceProvider';

export interface ProjectSpaceRouteParams {
  readonly id: string;
}

export interface ProjectSpaceRouteComponentProps extends RouteComponentProps<ProjectSpaceRouteParams> {}

export interface ProjectSpaceRouterOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}
export interface ProjectSpaceRouterStateProps {}
export type ProjectSpaceRouterProps = ProjectSpaceRouteComponentProps & ProjectSpaceRouterOwnProps & ProjectSpaceRouterStateProps;

export class ProjectSpaceRouterComponent extends React.Component<ProjectSpaceRouterProps> {
  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.projectPath(':id')} render={this.provider(this.props)} />
        <Route path={this.props.urls.projectPath(':id')} render={({ match }) => (
          //The Mixed Content feature removed all the subplaces under the Project place. If the user
          //tries to navigate to any subplace, redirect them to the main project place.
          <Redirect to={this.props.urls.projectPath(match.params.id)} />
        )} />
        <Route render={this.error} />
      </Switch>
    );
  }

  private provider = (providerProps: ProjectSpaceRouterProps): (props: ProjectSpaceRouteComponentProps) => JSX.Element => {
    return (props: ProjectSpaceRouteComponentProps): JSX.Element => {
      const projectSpaceProviderProps: ProjectSpaceProviderProps = {
        siteName: this.props.siteName,
        routeLocationSearch: props.location.search,
        routeLocationPath: props.location.pathname,
        projectId: props.match.params.id,
        urls: providerProps.urls,
      };
      return <ProjectSpaceProvider {...projectSpaceProviderProps} />;
    };
  }

  private error = (): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }
}

const mapStateToProps: MapStateToProps<ProjectSpaceRouterStateProps> = (state: AppState) => ({
  previousUrl: selectPreviousUrl(state),
});

// Component must *not* be pure as to allow route updates to flow through
export const ProjectSpaceRouter: React.ComponentClass<ProjectSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, {pure: false})(ProjectSpaceRouterComponent);
